'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PolicyCode$() {
  this.c8t = null;
  this.c8u = false;
  this.c8r = null;
  this.c8s = false;
}
export { $c_Lpresto_types$PolicyCode$ as $c_Lpresto_types$PolicyCode$ };
$p = $c_Lpresto_types$PolicyCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PolicyCode$;
/** @constructor */
function $h_Lpresto_types$PolicyCode$() {
}
export { $h_Lpresto_types$PolicyCode$ as $h_Lpresto_types$PolicyCode$ };
$h_Lpresto_types$PolicyCode$.prototype = $p;
$p.adB = (function() {
  if ((!this.c8u)) {
    this.c8t = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c8u = true;
  }
  return this.c8t;
});
$p.SQ = (function() {
  if ((!this.c8s)) {
    this.c8r = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c8s = true;
  }
  return this.c8r;
});
var $d_Lpresto_types$PolicyCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PolicyCode$, "presto.types$PolicyCode$", ({
  a0N: 1,
  D: 1
}));
export { $d_Lpresto_types$PolicyCode$ as $d_Lpresto_types$PolicyCode$ };
var $n_Lpresto_types$PolicyCode$;
function $m_Lpresto_types$PolicyCode$() {
  if ((!$n_Lpresto_types$PolicyCode$)) {
    $n_Lpresto_types$PolicyCode$ = new $c_Lpresto_types$PolicyCode$();
  }
  return $n_Lpresto_types$PolicyCode$;
}
export { $m_Lpresto_types$PolicyCode$ as $m_Lpresto_types$PolicyCode$ };
//# sourceMappingURL=presto.types$-Policy-Code$.js.map
